import { useState, useCallback } from 'react';

/**
 * useBulkSelect — row selection state for bulk table actions.
 *
 * Returns { selected: Set, toggle(id), toggleAll(ids), clear() }.
 * `toggleAll(ids)` selects all of `ids` unless they're all already selected,
 * in which case it clears.
 */
export function useBulkSelect() {
  const [selected, setSelected] = useState(() => new Set());
  const toggle = useCallback(id => setSelected(prev => {
    const next = new Set(prev);
    next.has(id) ? next.delete(id) : next.add(id);
    return next;
  }), []);
  const toggleAll = useCallback(ids => setSelected(prev => {
    const allOn = ids.length > 0 && ids.every(id => prev.has(id));
    return allOn ? new Set() : new Set(ids);
  }), []);
  const clear = useCallback(() => setSelected(new Set()), []);
  return { selected, toggle, toggleAll, clear };
}
